module.exports = __webpack_public_path__ + "assets/img/wf.abbf8ebe.svg";